import { useTranslation } from "react-i18next";
import {
  LandingHeader, LandingHero, StatBar, SecurityProofBand, FeaturesGrid, LandingPricing,
  PoliceBanner, ComplianceSection, MeaningSection, TrustSection,
  TestimonialsPlaceholder, FinalCTA, LandingFooter,
} from "@/components/LandingSections";

export default function Landing() {
  const { t } = useTranslation();
  const tags = t("tags", { returnObjects: true });

  return (
    <div className="bg-slate-50 text-stone-900">
      <LandingHeader t={t} />
      <LandingHero t={t} tags={tags} />
      <SecurityProofBand t={t} />
      <StatBar t={t} />
      <FeaturesGrid t={t} />
      <LandingPricing t={t} tags={tags} />
      <PoliceBanner t={t} />
      <ComplianceSection t={t} />
      <MeaningSection t={t} />
      <TrustSection t={t} />
      <TestimonialsPlaceholder t={t} />
      <FinalCTA t={t} />
      <LandingFooter t={t} />
    </div>
  );
}
